import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Row,
  Table,
  Modal,
  Input,
  Grid,
  Typography,
  Alert,
} from "antd";
import {
  API_BASE_URL,
  DELETE_DOCTOR,
  directToken,
  DOCTOR_LIST,
} from "../services/end_points";
import { _get } from "../services/service_api";
import axios from "axios";
import Icon, {
  BackwardOutlined,
  DeleteOutlined,
  EditOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import AddDoctor from "./AddDoctor";
import EditDoctor from "./EditDoctor";
import AddSlots from "./AddSlots";
import EditSlots from "./EditSlots";
import { useRoleData } from "../Data/Roledata";

const { useBreakpoint } = Grid;
const DoctorList = ({ handleRole }) => {
  const { column, rows } = useRoleData({ handleRole });
  const isAdmin = rows.some((row) => row.userType === "Admin");
  const [open, setOpen] = useState(false);
  const [doctor, setDoctor] = useState([]);
  const [availableSlots, setAvailableSlots] = useState(false);
  const [currentDoctorId, setCurrentDoctorId] = useState(null);
  const [chek, setCheck] = useState();
  const [datesSlots, setDateSlots] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [intervals, setIntervals] = useState([]);
  const [fromTime, setFromtime] = useState();
  const [editing, setEditing] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModelForSlots, setIsModelForSlots] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditdata] = useState([]);
  const [toTime, setTotime] = useState();
  const [activeIndex, setActiveIndex] = useState(null);
  const [selecteddates, useSlectedDates] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [openDialog, setOpenDialog] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const userId = localStorage.getItem("userid");
  const [alert, setAlert] = useState(null);
  const [activeView, setActiveView] = useState("default");
  const [view, setView] = useState("dates");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [slotsList, setSlotsList] = useState();
  const pageSize = 8;
  const slotsPerPage = 16;
  const [currentTimePage, setCurrentTimePage] = useState(0);

  const totalTimePages = Math.ceil(timeSlots.length / slotsPerPage);
  const handleChanges = (date, index) => {
    setCheck(date);
    setSelectedDate(date);
    setView("timeSlots");
    if (activeIndex === index) {
      setActiveIndex(null);
      return;
    } else {
      setActiveIndex(index);
      return;
    }
  };

  const handleBackClick = () => {
    setView("dates");
    setActiveIndex(null);
    setSelectedDate(null);
    setActiveView("default");
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (currentDoctorId !== null) {
      fetchSlotsList(currentDoctorId);
    }
  }, [currentDoctorId]);

  useEffect(() => {
    generateTimeSlots();
  }, [fromTime, toTime, intervals]);

  const handleEditforopup = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
    setIsEditing(true);
  };

  const fetchData = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${DOCTOR_LIST}${userId}`,
        directToken
      );
      if (response.data && response.data.list) {
        setDoctor(response.data.list);

        setFilteredDoctors(response.data.list);
      } else {
        console.error("Error fetching the data");
      }
    } catch (error) {
      console.error("Error fetching the data:", error);
    }
  };

  const fetchSlotsList = async (doctorId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/dateTime/get-Booked-List/${doctorId}`
      );
      if (response.data) {
        setSlotsList(response.data);
        setDateSlots(response.data.map((slot) => slot.date));
        setIntervals(response.data.map((slot) => slot.interval));
        setFromtime(response.data.map((slot) => slot.fromTime));
        setTotime(response.data.map((slot) => slot.toTime));
      } else {
        console.error("Error fetching the data");
      }
    } catch (error) {
      console.error("Error fetching the data:", error);
    }
  };
  const handleDateSelection = (date) => {
    setSelectedDate(date);
    const filteredSlots = filterAndGenerateSlots(slotsList, date);
    setTimeSlots(filteredSlots);
  };
  function generateTimeSlots(datesSlots, fromTime, toTime, intervals) {
    if (!datesSlots || !fromTime || !toTime || !intervals) {
      console.error("One or more input arrays are undefined");
      return [];
    }

    if (
      datesSlots.length !== fromTime.length ||
      datesSlots.length !== toTime.length ||
      datesSlots.length !== intervals.length
    ) {
      console.error("Input arrays are of different lengths");
      return [];
    }

    const slots = [];
    const generateSlotsForDate = (date, from, to, interval) => {
      const slotsForDate = [];
      try {
        let startTime = new Date(`${date} ${from}`);
        let endTime = new Date(`${date} ${to}`);

        if (startTime >= endTime) {
          console.error("Start time is not before end time");
          return slotsForDate;
        }
        while (startTime < endTime) {
          const endSlotTime = new Date(startTime.getTime() + interval * 60000);
          slotsForDate.push({
            date,
            startTime: startTime.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
            endTime: endSlotTime.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
          });
          startTime = endSlotTime;
        }
      } catch (error) {
        console.error("Error generating slots for date:", error);
      }

      return slotsForDate;
    };
    datesSlots.forEach((date, index) => {
      const from = fromTime[index];
      const to = toTime[index];
      const interval = intervals[index];
      const dateSlots = generateSlotsForDate(date, from, to, interval);
      slots.push(...dateSlots);
    });
    return slots;
  }
  const filterAndGenerateSlots = (slotsForDate, check) => {
    if (!slotsForDate || !Array.isArray(slotsForDate)) {
      console.error("Invalid slots list");
      return [];
    }
    const checkDateObj = new Date(check).toDateString();
    const filteredSlot = slotsForDate.find(
      (slot) => new Date(slot.date).toDateString() === checkDateObj
    );
    if (filteredSlot) {
      const { date, fromTime, toTime, interval } = filteredSlot;
      const newdate = [date];
      const newfromTime = [fromTime];
      const newtoTime = [toTime];
      const newinterval = [interval];
      return generateTimeSlots(newdate, newfromTime, newtoTime, newinterval);
    } else {
      console.log("No matching slot found for the given date.");
      return [];
    }
  };
  const fridayTimeSlots = filterAndGenerateSlots(slotsList, chek);
  const handleAvailableSlots = (doctorId) => {
    setCurrentDoctorId(doctorId);
    setAvailableSlots(true);
    setIsModelForSlots(true);
  };

  const splitIntoRows = (slots, slotsPerRow) => {
    const rows = [];
    for (let i = 0; i < slots.length; i += slotsPerRow) {
      rows.push(slots.slice(i, i + slotsPerRow));
    }
    return rows;
  };

  const [currentDatePage, setCurrentDatePage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const datesPerRow = 5;
  const rowsPerDatePage = 1;
  const slotsPerRow = 5;
  const rowsPerPage = 5;

  const dateRows = splitIntoRows(datesSlots, datesPerRow);

  const totalDatePages = Math.ceil(dateRows.length / rowsPerDatePage);

  const currentDates = dateRows.slice(
    currentDatePage * rowsPerDatePage,
    (currentDatePage + 1) * rowsPerDatePage
  );

  const handleNextDatePage = () => {
    if (currentDatePage < totalDatePages - 1) {
      setCurrentDatePage(currentDatePage + 1);
    }
  };

  const handlePreviousDatePage = () => {
    if (currentDatePage > 0) {
      setCurrentDatePage(currentDatePage - 1);
    }
  };

  const slotRows = splitIntoRows(fridayTimeSlots, slotsPerRow);

  const totalPages = Math.ceil(datesSlots.length / slotsPerPage);

  const currentSlots = slotRows.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage
  );

  const showModal = () => setIsModalVisible(true);
  const closeModal = () => {
    setIsModalVisible(false);
    // setIsEditing(false);
  };
  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleDelete = (data) => {
    axios
      .delete(`${API_BASE_URL}${DELETE_DOCTOR}${data}`)
      .then((response) => {
        setAlert({
          type: "success",
          message: response.data.message || "Doctor Deleted!",
        });
        fetchData();
      })
      .catch((error) => {
        console.error("Error deleting speciality:", error);
      });
  };

  const handleAddLocation = () => {
    setOpen(true);
  };
  // const handleButtonClick = (view) => {
  //   setActiveView(view);

  //   setIsModelForSlots(true);
  //   fetchSlotsList(currentDoctorId);
  // };
  const handleButtonClick = (view) => {
    // This ensures that the modal's views transition correctly.
    setActiveView(view);
    setIsModelForSlots(true); // Keeps the modal open

    // Fetch data as necessary for each view
    if (view === "addSlots" || view === "editSlots") {
      fetchSlotsList(currentDoctorId); // If you're showing slots, fetch slot data
    }
    if (view === "availableSlots") {
      fetchSlotsList(currentDoctorId); // If you're showing available slots, fetch those
    }
  };
  const handleClose = () => {
    setIsModelForSlots(false);
    fetchData();
    setAvailableSlots(false);
    setOpen(false);
    setEditing(false);

    // setActiveView("default");

    setOpenDialog(null);
  };
  const paginatedData = filteredDoctors.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    const filtered = doctor.filter((doctorItem) =>
      Object.values(doctorItem).some(
        (field) => field && field.toString().toLowerCase().includes(value)
      )
    );
    setFilteredDoctors(filtered);
  };
  const dynamicData = filteredDoctors.map((dataItem, index) => ({
    key: index,
    serialNumber: (
      <Typography
        display="block"
        variant="button"
        fontWeight="medium"
        fontSize="1.2rem"
      >
        {index + 1}
      </Typography>
    ),
    HospitalName: (
      <Typography
        display="block"
        variant="button"
        fontWeight="medium"
        fontSize="1.2rem"
      >
        {dataItem.hospitalName}
      </Typography>
    ),
    DoctorName: (
      <Typography
        display="block"
        variant="button"
        fontWeight="medium"
        fontSize="1.2rem"
      >
        {dataItem.doctorsName}
      </Typography>
    ),
    Speciality: (
      <Typography
        display="block"
        variant="button"
        fontWeight="medium"
        fontSize="1.2rem"
      >
        {dataItem.specialityName}
      </Typography>
    ),
    City: (
      <Typography
        display="block"
        variant="button"
        fontWeight="medium"
        fontSize="1.2rem"
      >
        {dataItem.cityName}
      </Typography>
    ),
    Area: (
      <Typography variant="caption" fontSize="0.9rem">
        {dataItem.areaName}
      </Typography>
    ),
    Charges: (
      <Typography variant="caption" fontSize="0.9rem">
        {dataItem.charges}
      </Typography>
    ),
    Action: (
      <div>
        <Button
          size="small"
          onClick={() => handleAvailableSlots(dataItem.id)}
          style={{
            border: "1px solid #0d63ee",
            color: "#0d63ee",
            marginRight: "8px",
          }}
        >
          Slots
        </Button>
        <Button
          onClick={() => handleEditforopup(dataItem)}
          size="small"
          style={{
            border: "1px solid #0899f9",
            color: "#0899f9",
            marginRight: "8px",
          }}
        >
          <EditOutlined />
        </Button>
        {rows[0]?.id === 1 && (
          <Button
            size="small"
            style={{
              marginLeft: "5px",
              fontSize: "12px",

              border: "1px solid #941717",
              color: "#941717",
            }}
            onClick={() => handleDelete(dataItem.id)}
          >
            <DeleteOutlined />
          </Button>
        )}
      </div>
    ),
  }));

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const screens = useBreakpoint();
  let modalWidth;
  if (screens.xl) {
    modalWidth = 670;
  } else if (screens.lg) {
    modalWidth = 650;
  } else if (screens.md) {
    modalWidth = 500;
  } else if (screens.sm) {
    modalWidth = 400;
  } else {
    modalWidth = 400;
  }
  const columns = [
    {
      title: "S.No",
      dataIndex: "serialNumber",
      key: "serialNumber",
    },
    {
      title: "Hospital Name",
      dataIndex: "HospitalName",
      key: "HospitalName",
    },
    {
      title: "Doctor Name",
      dataIndex: "DoctorName",
      key: "DoctorName",
    },
    {
      title: "Speciality",
      dataIndex: "Speciality",
      key: "Speciality",
    },
    {
      title: "City",
      dataIndex: "City",
      key: "City",
    },
    {
      title: "Area",
      dataIndex: "Area",
      key: "Area",
    },
    {
      title: "Charges",
      dataIndex: "Charges",
      key: "Charges",
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
    },
  ];
  const updateUserList = (newUser) => {
    setDoctor((prevUser) => {
      // Check if the user is being added or updated
      const index = prevUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...prevUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    setFilteredDoctors((prevFilteredUser) => {
      const index = prevFilteredUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...prevFilteredUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevFilteredUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    fetchData();
  };
  return (
    <>
      <DefaultLayout>
        <Card style={{ width: "100%", minHeight: "600px", height: "100%" }}>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            {alert && (
              <Alert
                style={{
                  backgroundColor:
                    alert.type === "success" ? "#ff1c1cbf" : "#f44336",
                  color: "white",
                  width: "30%",
                  textAlign: "center",
                }}
                closable
                onClose={handleClose}
                message={alert.message}
                closeIcon={
                  <span style={{ color: "white", fontSize: "20px" }}>×</span>
                }
              />
            )}
          </div> */}
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <h2>Doctor List</h2>
            </Col>
            <Col xs={24} sm={24} md={10} lg={10} xl={10}>
              <Input
                style={{ width: "100%", height: "45px" }}
                placeholder="Search Doctor"
                onChange={handleSearch}
              />
            </Col>
            <Col
              xs={24}
              sm={24}
              md={6}
              lg={6}
              xl={6}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                style={{
                  backgroundColor: "#6499f1",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  width: "100%",
                  height: "48px",
                  maxWidth: "200px",
                }}
                onClick={showModal}
              >
                Create Doctor
              </Button>
            </Col>
          </Row>

          <Row>
            <Col xs={24} sm={24} md={22} lg={20} xl={24}>
              <div
                style={{
                  width: "100%",
                  overflowX: "auto",
                }}
              >
                <Table
                  columns={columns}
                  dataSource={dynamicData}
                  rowKey="key"
                  pagination={{ pageSize: 8 }}
                  scroll={{ x: true }}
                />
              </div>
            </Col>
          </Row>
          <Modal
            title={isEditing ? "Edit Doctor" : "Create Doctor"}
            visible={isModalVisible}
            onCancel={closeModal}
            footer={null}
            width={modalWidth}
          >
            {isEditing ? (
              <EditDoctor data={selectedRecord} />
            ) : (
              <AddDoctor updateUserList={updateUserList} />
            )}
          </Modal>
          <Modal
            title="Slots"
            visible={isModelForSlots}
            onCancel={handleClose}
            width={700}
            footer={null}
          >
            {/* Default View (Landing page for selecting options) */}
            {activeView === "default" && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  justifyItems: "center",
                }}
              >
                <Button
                  onClick={() => handleButtonClick("addSlots")}
                  style={{
                    marginRight: "10px",
                    background: "#0899f9",
                    color: "white",
                  }}
                >
                  Add Slots
                </Button>
                <Button
                  onClick={() => handleButtonClick("editSlots")}
                  style={{
                    marginRight: "10px",
                    background: "#0899f9",
                    color: "white",
                  }}
                >
                  Edit Slots
                </Button>
                <Button
                  style={{ background: "#0899f9", color: "white" }}
                  onClick={() => handleButtonClick("availableSlots")}
                >
                  Available Slots
                </Button>
              </div>
            )}

            {activeView === "addSlots" && <AddSlots data={currentDoctorId} />}
            {activeView === "editSlots" && (
              <>
                <EditSlots data={currentDoctorId} />
              </>
            )}

            {activeView === "availableSlots" && (
              <div>
                {!selectedDate && datesSlots.length > 0 && (
                  <div>
                    <h3>Select a Date</h3>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "16px",
                        gap: "16px",
                      }}
                    >
                      <Button
                        onClick={handlePreviousDatePage}
                        disabled={currentPage === 0}
                        style={{ color: "#1236fa" }}
                        icon={<LeftOutlined />}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        {currentDates.map((row, rowIndex) => (
                          <React.Fragment key={rowIndex}>
                            {row.map((date, index) => (
                              <Button
                                size="small"
                                key={index}
                                onClick={() => handleChanges(date, index)}
                                style={{
                                  border: "1px solid #0899f9",
                                  fontSize: "11px",
                                  width: "98px",
                                  backgroundColor: "white",
                                  color: "#0899f9",
                                  marginRight: "8px",
                                }}
                              >
                                {date}
                              </Button>
                            ))}
                          </React.Fragment>
                        ))}
                      </div>
                      <Button
                        onClick={handleNextDatePage}
                        disabled={currentPage === totalPages - 1}
                        style={{ color: "#1236fa" }}
                        icon={<RightOutlined />}
                      />
                    </div>
                  </div>
                )}

                <div>
                  {selectedDate ? (
                    fridayTimeSlots.length > 0 ? (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "10px",
                            marginTop: "16px",
                          }}
                        >
                          {/* Previous Button for Time Slots */}
                          <Button
                            onClick={handlePreviousPage}
                            disabled={currentPage === 0}
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                              color: "#1236fa",
                            }}
                          >
                            <LeftOutlined />
                          </Button>

                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(3, 1fr)", // 4 items per row
                              gap: "8px",
                              width: "100%", // To ensure buttons take full width
                            }}
                          >
                            {currentSlots.map((row, rowIndex) => (
                              <React.Fragment key={rowIndex}>
                                {row.map((slot, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Button
                                      size="small"
                                      style={{
                                        border: "1px solid #0899f9",
                                        fontSize: "12px",
                                        width: "140px",
                                        borderRadius: "14px",
                                        backgroundColor: "white",
                                        color: "#0899f9",
                                      }}
                                    >
                                      {`${slot.startTime} - ${slot.endTime}`}
                                    </Button>
                                  </div>
                                ))}
                              </React.Fragment>
                            ))}
                          </div>

                          {/* Next Button for Time Slots */}
                          <Button
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages - 1}
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                              color: "#1236fa",
                            }}
                          >
                            <RightOutlined />
                          </Button>
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          marginTop: "16px",
                          color: "#ff0000",
                          textAlign: "center",
                        }}
                      >
                        No slots available
                      </div>
                    )
                  ) : (
                    <div
                      style={{
                        marginTop: "16px",
                        color: "#ff0000",
                        textAlign: "center",
                      }}
                    >
                      Select a date to view available slots
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Back Button to transition between views */}
            <Button
              size="small"
              onClick={handleBackClick}
              style={{
                marginLeft: "0px",
                marginTop: "5px",
                color: "#1236fa",
                background: "white",
              }}
            >
              <BackwardOutlined />
            </Button>
          </Modal>
        </Card>
      </DefaultLayout>
    </>
  );
};
export default DoctorList;
